// Generated by Melange

import * as Warblre_js__Interop from "warblre-engines.js/Interop.mjs";

const success = Warblre_js__Interop.success;

const error = Warblre_js__Interop.error;

const erased = Warblre_js__Interop.erased;

export {
  success,
  error,
  erased,
}
/* No side effect */
